// extracted by mini-css-extract-plugin
export default {"record_type_label":"RecordTypeLabel_record_type_label__qWkxg","spin":"RecordTypeLabel_spin__kU8zX"};